import httpClient from '../httpClient';

export async function getAllOrgInterOrdemCompra() {
  try {
    const response = await httpClient.get(`/api/orginter-ordemcompra`);

    // Verifica se response.data existe antes de acessar registros
    if (!response.data || !Array.isArray(response.data.registros)) {
      console.warn('API retornou um formato inesperado:', response.data);
      return [];
    }

    return response.data.registros;
  } catch (error) {
    console.error('Erro ao obter dados:', error);
    return [];
  }
}

export async function getOrgInterOrdemCompra(id: string) {
  try {
    const response = await httpClient.get(`/api/orginter-ordemcompra/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}

export async function getOrdemCompraPorTermoReferencia(id: string) {
  try {
    const response = await httpClient.get(
      `/api/orginter-ordemcompra/termoreferencia/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados: ' + error);
  }
}
